import React from 'react'
import { Box } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DatePicker, DatePickerAnchorField } from 'components/global/CUK/DatePicker'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import { DEFAULT_COUPON } from './use-save'
import { trackEvent } from 'analytics'

const DurationField: React.FC = () => {
  const { t } = useTranslation()
  const { control, resetField, formState: { errors } } = useFormContext()

  interface DateError {
    startDate?: { message?: string }
    endDate?: { message?: string }
  }
  const dateErrors = errors.dates as DateError | undefined
  const hasError = Boolean(dateErrors?.startDate || dateErrors?.endDate)

  return (
    <Box sx={{ width: '100%' }}>
      <FieldLabel 
        labelKey="coupons.create.validity_period" 
        tooltip="coupons.create.validity_period_tooltip" 
      />
      <Controller
        control={control}
        name="dates"
        render={({ field: { value, onChange } }) => (
          <DatePicker
            placement="left"
            showPresets={false}
            blockFutureDates={false}
            blockPastDates={true}
            name="dates"
            defaultStartDate={DEFAULT_COUPON.dates.startDate}
            defaultEndDate={DEFAULT_COUPON.dates.endDate}
            field={
              <DatePickerAnchorField
                locale="fr"
                isdate={true}
                startDate={value?.startDate}
                endDate={value?.endDate}
                placeholder={t('coupons.create.dates_interval_placeholder')}
                hasError={hasError}
                onReset={() => {
                  resetField('dates')
                  resetField('startDate')
                  resetField('endDate')
                }}
                sx={{
                  height: 40,
                  width: '100%'
                }}
              />
            }
            onSubmit={(startDate, endDate) => {
              onChange({ startDate, endDate })
              trackEvent('change_validity_start', { has_value: Boolean(startDate) })
              trackEvent('change_validity_end', { has_value: Boolean(endDate) })
            }}
          />
        )}
      />
      {dateErrors && (
        <ErrorMessage
          message={dateErrors?.startDate?.message || dateErrors?.endDate?.message}
        />
      )}
    </Box>
  )
}

export default DurationField